import { render } from "./RegistrationFieldNurse.vue?vue&type=template&id=85bf24d4&scoped=true&ts=true"
import script from "./RegistrationFieldNurse.vue?vue&type=script&lang=ts"
export * from "./RegistrationFieldNurse.vue?vue&type=script&lang=ts"

import "./RegistrationFieldNurse.vue?vue&type=style&index=0&id=85bf24d4&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85bf24d4"]])

export default __exports__